import React, { useRef } from 'react';
import * as THREE from 'three';
import { useFrame } from '@react-three/fiber';

interface GlassRodProps {
  position?: [number, number, number];
  rotation?: [number, number, number];
  scale?: number;
  isStirring?: boolean;
  stirCenter?: [number, number, number];
  stirRadius?: number;
}

export function GlassRod({
  position = [0, 0, 0],
  rotation = [0, 0, 0],
  scale = 1,
  isStirring = false,
  stirCenter,
  stirRadius = 0.06,
}: GlassRodProps) {
  const groupRef = useRef<THREE.Group>(null);
  const basePos = useRef<[number, number, number]>(position);

  useFrame((state) => {
    if (!groupRef.current) return;
    if (isStirring && stirCenter) {
      const t = state.clock.elapsedTime * 4;
      const x = stirCenter[0] + Math.cos(t) * stirRadius;
      const z = stirCenter[2] + Math.sin(t) * stirRadius;
      groupRef.current.position.set(x, basePos.current[1], z);
      groupRef.current.rotation.z = Math.sin(t) * 0.15;
      groupRef.current.rotation.x = Math.cos(t) * 0.15;
    } else {
      groupRef.current.position.set(basePos.current[0], basePos.current[1], basePos.current[2]);
      groupRef.current.rotation.set(rotation[0], rotation[1], rotation[2]);
    }
  });

  return (
    <group ref={groupRef} position={position} rotation={rotation} scale={scale}>
      <mesh castShadow>
        <cylinderGeometry args={[0.006, 0.006, 0.55, 16]} />
        <meshPhysicalMaterial
          color="#dcf0ff"
          transparent
          opacity={0.7}
          roughness={0.05}
          transmission={0.85}
          ior={1.47}
          thickness={0.012}
          clearcoat={1}
        />
      </mesh>
      <mesh position={[0, -0.275, 0]}>
        <sphereGeometry args={[0.007, 16, 16]} />
        <meshPhysicalMaterial
          color="#dcf0ff"
          transparent
          opacity={0.7}
          roughness={0.05}
          transmission={0.85}
          ior={1.47}
        />
      </mesh>
      <mesh position={[0, 0.275, 0]}>
        <sphereGeometry args={[0.007, 16, 16]} />
        <meshPhysicalMaterial
          color="#dcf0ff"
          transparent
          opacity={0.7}
          roughness={0.05}
          transmission={0.85}
          ior={1.47}
        />
      </mesh>
    </group>
  );
}

export default GlassRod;
